import React from 'react'

export const ContextAPI = React.createContext({});
